import helper from './helper'

const getSignerUrlWithParameters = helper.getSignerUrlWithParameters

export default {
  getSignerUrlWithParameters,
  getByRecievedUrlData: (url, gets = null) => getSignerUrlWithParameters(
    /**
     * Функция для построения URL из предопределенного объекта URL
     * @param {Object} url - объект конфигурации URL
     * @param {Object} gets - дополнительные query параметры (опционально)
     * @returns {string} строка URL
     */
    url.basename,
    url.action,
    url.params,
    gets
  ),
  SIGNER: {
    LIST:
      (gets = null) => getSignerUrlWithParameters(
        /**
         * Получает список документов для подписи
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для получения списка документов
         */
        'self|documents-list',
        'list',
        null,
        gets
      ),
    CREATE:
      (gets = null) => getSignerUrlWithParameters(
        /**
         * Добавляет электронную подпись к документу
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для создания подписи
         */
        'self|documents-list',
        'create',
        null,
        gets
      ),
    DETAIL:
      (id, gets = null) => getSignerUrlWithParameters(
        /**
         * Получает детальную информацию о документе
         * @param {string|number} id - идентификатор документа
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для получения деталей документа
         */
        'self|documents-detail',
        'retrieve',
        { id },
        gets
      ),
    DISPATCHED:
      /**
       * Получает информацию об отправленных документах
       * @param {string|number} id - идентификатор документа
       * @param {Object} gets - дополнительные query параметры (опционально)
       * @returns {string} URL для получения информации об отправленных документах
       */
      (id, gets = null) => getSignerUrlWithParameters(
        'self|documents-dispatched',
        'dispatched',
        { id },
        gets
      ),
    SEND_MAIL:
      (document, recipient, gets = null) => getSignerUrlWithParameters(
        /**
         * Отправляет документ на почту получателю
         * @param {string|number} document - идентификатор документа
         * @param {string|number} recipient - идентификатор получателя
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для отправки документа по почте
         */
        'self|document-to-recipient-send',
        'post',
        { document, recipient },
        gets
      ),
    DOCUMENTS_CHECK:
      /**
       * Проверяет целостность документа
       * @param {Object} gets - дополнительные query параметры (опционально)
       * @returns {string} URL для проверки целостности документа
       */
      (gets = null) => getSignerUrlWithParameters(
        'self|documents-check',
        'check',
        null,
        gets
      )
  }
}
